export const zh_CHT = {
    static: {
        approvalLogs: {
            title: '審批記錄',
            approvalOpinion: '審批意見',
            startTime: '接收時間',
            endTime: '處理時間',
            todo: '待辦理',
            done: '已辦理',
            toAssign: '未指派'
        },
        flowchart: {
            title: '查看流程',
            processNotFound: '流程實例ID為空',
            dataIdIsNull: '單據內碼為空',
            flowChart: '流程圖',
            complete: '隱藏計算路線',
            simulation: '顯示計算路線',
            sequenceColor: '分支線顏色說明',
            completed: '已運行',
            calculate: '計算路線',
            default: '默認',
            suspend: '計算中斷',
            noProcess: '未找到符合條件的流程定義！',
            list: '流程列表',
            noDataId: '單據內碼為空',
            noBizDefKey: '流程分類ID為空'
        }
    }
};
